module.exports = __webpack_public_path__ + "img/invictus_logo.996d1af6.png";